import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "动漫分类", to: "/category" },
      { label: "动漫资讯", to: "/news" },
      { label: "搜索", to: "/search" },
    ],
  },
  {
    title: "热门类型",
    links: [
      { label: "热血动漫", to: "/category?type=热血" },
      { label: "恋爱动漫", to: "/category?type=恋爱" },
      { label: "科幻动漫", to: "/category?type=科幻" },
      { label: "治愈动漫", to: "/category?type=治愈" },
    ],
  },
  {
    title: "关于",
    links: [
      { label: "关于动漫天堂", to: "/about" },
      { label: "内容说明", to: "/about#notice" },
      { label: "联系方式", to: "/about#contact" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-page px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
                <i className="ri-tv-2-line" />
              </span>
              <span className="font-heading text-xl font-extrabold text-background-50">动漫天堂</span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-7 text-background-200/90">
              一个为动漫爱好者准备的内容站：聚合国内外动漫资源，提供分类浏览、剧情介绍与最新资讯，帮你在海量作品里快速找到下一部想看的动画。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: "ri-weibo-line", label: "微博", href: "https://ialgroup.asia" },
                { icon: "ri-bilibili-line", label: "哔哩哔哩", href: "https://www.bilibili.com" },
                { icon: "ri-mail-line", label: "邮箱", href: "mailto:hello@anime-paradise.demo" },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  aria-label={item.label}
                  target={item.href.startsWith("http") ? "_blank" : undefined}
                  rel={item.href.startsWith("http") ? "noopener noreferrer" : undefined}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/25 text-base text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
                >
                  <i className={item.icon} />
                </a>
              ))}
              <Link
                to="/about"
                aria-label="关于我们"
                className="flex h-9 w-9 items-center justify-center rounded-full border border-background-100/25 text-base text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
              >
                <i className="ri-article-line" />
              </Link>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-semibold uppercase tracking-widest text-primary-300">
                {column.title}
              </h3>
              <ul className="mt-5 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-200/85 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 动漫天堂 · 本站内容均为演示数据，不提供播放与下载服务。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>内容仅供学习与交流</span>
            <span className="hidden sm:inline text-background-400/50">|</span>
            <Link to="/about#notice" className="hover:text-background-50">使用说明</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}